// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function RedditLogoIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M31 13a4 4 0 0 0-6.617-3.024c-2.094-1.112-4.595-1.785-7.208-1.941l.649-3.896 2.215.34a3 3 0 1 0 .358-1.968l-3.25-.5a1 1 0 0 0-1.138.824L15.15 8.02c-2.73.117-5.353.798-7.533 1.956a4 4 0 0 0-5.323 5.968A7.376 7.376 0 0 0 2 18c0 2.741 1.5 5.294 4.239 7.186C8.86 27 12.326 28 16 28c3.674 0 7.14-1 9.761-2.814C28.5 23.294 30 20.741 30 18c0-.696-.1-1.388-.294-2.056A4.02 4.02 0 0 0 31 13ZM23 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm5.016 11.723a1 1 0 0 0-.411 1.25c.26.644.394 1.332.395 2.027 0 2.066-1.199 4.034-3.375 5.541C22.334 25.125 19.271 26 16 26s-6.334-.875-8.625-2.459C5.199 22.034 4 20.066 4 18a5.47 5.47 0 0 1 .393-2.021 1 1 0 0 0-.41-1.25 2 2 0 1 1 2.634-2.905 1 1 0 0 0 1.307.278l.045-.027C10.18 10.738 13.03 10 16 10c2.966 0 5.816.738 8.029 2.075l.052.031a1 1 0 0 0 1.299-.282 2.001 2.001 0 1 1 2.634 2.899h.002ZM11 18a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm12-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-2.116 5.531a1 1 0 0 1-.415 1.353 9.522 9.522 0 0 1-8.938 0 1 1 0 1 1 .938-1.768 7.521 7.521 0 0 0 7.062 0 1 1 0 0 1 1.353.415Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
